import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons'
import React, { useState } from 'react'

const styles = {
  fileUploadContainer: {
    position: 'relative',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '100%',
  },

  fileUploadInput: {
    position: 'absolute',
    zIndex: 10,
    opacity: 0,
    width: '100%',
    left: 0,
    height: '31px',
  },

  uploadButton: {
    backgroundColor: '#37c2de',
    color: '#fff',
    display: 'inline-block',
    borderRadius: '4px',
    padding: '10px 20px',
  },

  moveToFolder: {
    background: '#f1f1f1',
    display: 'inline-block',
    height: '30px',
    marginLeft: '20px',
  },

  fileName: {
    fontSize: '12px',
    marginLeft: '15px',
  },
}

const File = (props) => {
  const [originalName, setOriginalName] = useState('')

  const onChange = (event) => {
    const originalNameSplit = event.target.value.split(/(\\|\/)/g)
    setOriginalName(originalNameSplit[originalNameSplit.length - 1])
    if (typeof props.onChange === 'function') {
      props.onChange(event.target.files[0], props.name)
    }
  }

  return (
    <div className='upload-video-form-row'>
      <div style={styles.fileUploadContainer}>
        <span className='text-sm' style={styles.uploadButton}>
          <FontAwesomeIcon icon={faCloudArrowUp} className='mr-2' />
          {props.placeholder || 'Choose file'}
        </span>

        <input
          name={props.name || 'file'}
          onChange={onChange}
          style={styles.fileUploadInput}
          type='file'
        />
        <span style={styles.fileName}>
          {originalName
            ? originalName
            : props.originalName && props.originalName}
        </span>
      </div>
    </div>
  )
}

export default File
